import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';
import Button from '../UI/Button';

const ProjectAiPanel: React.FC<{
  title: string;
  placeholder: string;
  generating: boolean;
  hasExisting?: boolean;
  onGenerate: (prompt: string, action: 'generate' | 'revise') => void;
}> = ({ title, placeholder, generating, hasExisting, onGenerate }) => {
  const [prompt, setPrompt] = useState('');
  return (
    <div className="rounded-xl border border-primary-200 bg-primary-50/50 p-4 space-y-3">
      <p className="text-sm font-medium text-primary-900 inline-flex items-center gap-2">
        <Sparkles className="h-4 w-4" /> Generate or review with AI
      </p>
      <textarea
        className="w-full rounded-md border-gray-300 text-sm"
        rows={3}
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder={placeholder}
      />
      <div className="flex flex-wrap gap-2">
        <Button type="button" size="sm" isLoading={generating} onClick={() => onGenerate(prompt, hasExisting ? 'revise' : 'generate')}>
          {hasExisting ? 'Review / update with AI' : title}
        </Button>
      </div>
    </div>
  );
};

export default ProjectAiPanel;
